import { fetchAPI } from '@/shared/lib/api/client';

export type GiftMeta = {
  is_unique: boolean;
  collection_num: number | null;
  model_name: string | null;
  pattern_name: string | null;
  backdrop_name: string | null;
  rarity_permille: number | null;
  thumbnail_url: string | null;
};

export type ShopGiftListing = {
  id: string;
  gift_id: string;
  name: string;
  emoji: string;
  slug: string;
  value_ton: number;
  price_ton: number;
  is_lost: boolean;
  is_exclusive: boolean;
  lost_at: string;
  original_owner_id: string;
} & GiftMeta;

export type ShopListingsResponse = {
  listings: ShopGiftListing[];
  total: number;
};

export type BuyGiftResponse = {
  success: boolean;
  gift_id: string;
  action_type: string;
};

export async function fetchShopListings(): Promise<ShopGiftListing[]> {
  const { data } = await fetchAPI.get<ShopListingsResponse>('/shop/gifts');
  return data.listings;
}

export async function buyGiftListing(listingId: string): Promise<BuyGiftResponse> {
  const { data } = await fetchAPI.post<BuyGiftResponse>(`/shop/gifts/${listingId}/buy`);
  return data;
}

// ---------------------------------------------------------------------------
// Inventory
// ---------------------------------------------------------------------------

export type InventoryGift = {
  id: string;
  telegram_gift_id: string;
  slug: string;
  name: string;
  emoji: string;
  value_stars: number;
  value_ton: number;
  value_usd: number;
  status: string;
} & GiftMeta;

export type InventoryResponse = {
  gifts: InventoryGift[];
  total: number;
};

export type WithdrawResponse = {
  success: boolean;
  gift_id: string;
  message: string;
};

export async function fetchInventory(): Promise<InventoryGift[]> {
  const { data } = await fetchAPI.get<InventoryResponse>('/gifts/inventory');
  return data.gifts;
}

export async function withdrawGift(giftId: string): Promise<WithdrawResponse> {
  const { data } = await fetchAPI.post<WithdrawResponse>(`/gifts/${giftId}/withdraw`);
  return data;
}
